import React, {useState} from 'react'
import PropTypes from 'prop-types';
import { 
  Button,
  Tooltip,
  ButtonGroup,
} from 'reactstrap';
import Select from 'react-select';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function Title({
  className,
  button, 
  select,
  search,
  searchProps,
  buttonProps,
  selectProps,
  children
}) {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const toggle = () => setTooltipOpen(!tooltipOpen);

  return (
    <div className={`${className}`}>
      <div className="d-inline">
        <h3 className="text-dark d-inline font-weight-bold">
          {children}
        </h3>
      </div>
      { button && <>
        { buttonProps?.tooltip && buttonProps?.disabled && 
          <Tooltip placement="top" isOpen={tooltipOpen} target="TooltipTitleButton" toggle={toggle}>
            {buttonProps?.tooltip}
          </Tooltip> 
        }
        <ButtonGroup className={clsx('float-right', buttonProps?.className)}>
          <Button 
              id="TooltipTitleButton"
              color={buttonProps?.color ?? 'light'} 
              className={clsx(buttonProps?.disabled && 'disabled')}
              size={buttonProps?.size ?? 'sm'}
              onClick={buttonProps?.onClick}
              // disabled={buttonProps?.disabled}
          >
            {buttonProps?.text}
          </Button> 
         {buttonProps.help && <Button 
              id="TooltipHelpButton"
              color={buttonProps?.color ?? 'light'} 
              size={buttonProps?.size ?? 'sm'}
              onClick={buttonProps?.onHelp}
          >
            <FontAwesomeIcon icon="question-circle" className="text-muted" />
          </Button>}
        </ButtonGroup>
      </>}
      { search && 
          <input 
              // color={searchProps?.color ?? 'primary'} 
              placeholder={searchProps?.label}
              className={`float-right search-input align-self-center border rounded ${searchProps?.className ?? ''}`}
              // size={searchProps?.size ?? 'sm'}
              value={searchProps?.value}
              onChange={searchProps?.onChange}
              // disabled={searchProps?.disabled}
          /> 
      }
      {
        select && <div className="float-right d-flex"> 
          <span className="text-dark px-1 align-self-center">{selectProps?.label}</span> 
          <Select 
            className="trato-select"
            width='200px'
            isSearchable
            classNamePrefix="trato-select"
            defaultValue={selectProps?.options.find(option => option.value === selectProps?.defaultValue)}
            options={selectProps?.options ?? []}
            onChange={selectProps?.onChange}
          />
        </div>
      }
    </div>
  )
}

Title.propTypes = {

}

export default Title

